import React, { useEffect } from "react";
import { Grid } from "@mui/material";

import {
    BreadCrumbs,
    PageTitleWithToolTip,
    AddButton,
    CircularLoading
} from "../../Common";

import EmailAlertTable from "./CustomTable/Table";
import TooltipNode from './TooltipNode'
import useEmailAlert from "./context/useEmailAlert";
import EmailAlertFormModal from "./EmailAlertFormModal";
import EmailAlertTablePlaceholder from "./EmailAlertTablePlaceholder";

const EmailAlerts = () => {
    const {
        onChangeModalState,
        initializeEmailAlertData,
        tableData,
        isLoading
    } = useEmailAlert();

    useEffect(() => {
        initializeEmailAlertData();
    }, [])

    return (
        <>
            <BreadCrumbs
                path={[
                    { text: "Account Details", to: `/Account` },
                    { text: "Manage Email Alerts" },
                ]}
            />
            <Grid
                container
                direction="row"
                alignItems="center"
            >
                <Grid item xs={6} md={6} lg={6}>
                    <PageTitleWithToolTip
                        PageTitleWithToolTip
                        pageTitle={"Manage Email Alerts"}
                        toolTipNode={<TooltipNode />}
                    />
                </Grid>
                <Grid item align="right" sx={{ marginLeft: "auto" }}>
                    <AddButton
                        text={"Create new email alert"}
                        onClick={onChangeModalState}
                        disabled={isLoading}
                    />
                </Grid>
                <Grid item xs={12} mt={"30px"}>
                    {
                        isLoading
                            ? (
                                <div className="tablediv">
                                    <CircularLoading CircularLoading size={35} marginTop={1} />
                                </div>
                            ) : (
                                (tableData && tableData.length) > 0 ? <EmailAlertTable /> : <EmailAlertTablePlaceholder />
                            )
                    }
                </Grid>
            </Grid>
            <EmailAlertFormModal />
        </>
    )
};

export default EmailAlerts;